<template>
  <div class="login-root">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-8 col-sm-12" v-bind:style="Style1">
          <div class="app-title">
            <h1>门头沟区文化保护传承“六四一”模式</h1>
            <hr />
          </div>
          <!-- <div class="app-sub-title">{{appNameEnglish}}</div> -->

         
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12" v-bind:style="Style">
          <div class="form">
            <div class="group">
              用户名：
              <el-input v-model="user.username" size="mini" placeholder="请输入密码"></el-input>
            </div>
            <div class="group">
              密码：
              <el-input v-model="user.password" size="mini" show-password  placeholder="请确认密码"></el-input>
            </div>
            <div class="group">
              <!-- <a class="a" @click="regNew">注册</a> -->
              <el-button type="primary" plain @click="loginFn()" size="mini">登录</el-button>
              <el-button type="primary" size="mini" plain @click="cancle()">取消</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Login",
  data() {
    return {
      Style: {
        paddingTop: window.innerHeight / 2 - 150 + "px"
      },
      Style1: {
        paddingTop: window.innerHeight / 2 - 50 + "px"
      },
      user: {
        username: "", 
        password: ""
      }, 
    };
  },
  computed: {},
  components: {},
  methods: {
    cancle() {
      this.user = {
        username: "",
        password: ""
      };
      this.$router.push({ path: "/" });
    },

    loginFn() { 
      let that = this;
      this.$axios({
        method: "post",
        url: "/api/user_app/login/",
        data: that.user
      }).then(response => {
        if (response.data.access) { 
          document.onkeyup = null;
          that.$cookies.set(
            "access",
            response.data.access,
            1000 * 60 * 60 * 24 * 7
          );
          that.$cookies.set(
            "refresh",
            response.data.refresh,
            1000 * 60 * 60 * 24 * 7
          );
          that.$cookies.set(
            "username",
            that.user.username,
            1000 * 60 * 60 * 24 * 7
          );
          this.$store.commit("setUserName", that.user.username);
          that.$router.push({ path: "/" });
        } else {
          that.$message("用户名或密码错误！");
        }
      });
    }, 
    regNew() {
      this.$router.push({ path: "/register" });
    }
  },
  mounted() {},
  created() {
    let that = this;
    document.onkeyup = function() {
      let key = window.event.keyCode;
      if (key === 13) {
        that.loginFn();
      }
    };
  }
};
</script>

<style scoped lang="less" src="./Login.less"></style>
